import io from 'socket.io-client'

// export const socket = io.connect('https://api.contractpro360.com/api');
export const socket = io.connect('https://api.contractpro360.com');
